export const FrontendMarkForListingStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  UnderReview: 'Under Review',
  Sold: 'Sold',
  Draft: 'Draft',
};

export const ExternalIdGroupByOrigin = {
  RAE: 'E',
  Repliers: 'R',
  Pillar9: 'A',
};

export const BCInteriorCities = [
  'Anglemont',
  'Armstrong',
  'Blind Bay',
  'Big White',
  'Cadreb Other',
  'Coldstream',
  'Eagle Bay',
  'Enderby',
  'Falkland',
  'Grindrod',
  'Kelowna',
  'Lake Country',
  'Lumby',
  'Lee Creek',
  'Mabel Lake',
  'Magna Bay',
  'Malakwa',
  'McLure',
  'Oliver',
  'Peachland',
  'Penticton',
  'Revelstoke',
  'Salmon Arm',
  'Sicamous',
  'Seymour Arm',
  'Shuswap Lake',
  'St. Ives',
  'Vernon',
  'West Kelowna',
  'Westbank',
  'Cherryville',
];

export const ListingAgreementStatus = {
  NotCreated: 'NOT-CREATED-YET',
};
